export type AtVirtualClinicSaps3ChirurgischerStatus = '1' | '2' | '3';

export const AT_VIRTUAL_CLINIC_SAPS3_CHIRURGISCHER_STATUS_DISPLAY_NAMES: {
  [status in AtVirtualClinicSaps3ChirurgischerStatus]: string;
} = {
  '1': 'Elektive Chirurgie',
  '2': 'Notfalls-Eingriff',
  '3': 'Kein chirurgischer Eingriff',
};
